import { yup } from '@framework/validation';

export enum MapUploadGeometriesType {
  GeoJSON = 'geojson',
  Shapefile = 'shapefile',
}

export const MapUploadGeometriesSchema = yup.object({
  type: yup
    .string()
    .oneOfEnum(MapUploadGeometriesType)
    .required()
    .default(MapUploadGeometriesType.GeoJSON)
    .label('Tipo'),

  files: yup.mixed().required().label('File'),
});
